import React from "react"

const transparent1x1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="

class ImageWithFallback extends React.Component {

  times = 0
  state = {
    noImage: false
  }

  componentDidUpdate( prevProps ) {
    if ( prevProps.src !== this.props.src ) {
      this.times = 0
      this.setState( { noImage: false, isFallback: false, Child: null } )
    }
  }

  shouldForceFallback = ( loadedSrc ) => {
    if ( !loadedSrc ) return false
    const { forceFallbackIfUrlMatches } = this.props
    if ( !forceFallbackIfUrlMatches ) return false

    const patterns = Array.isArray( forceFallbackIfUrlMatches )
      ? forceFallbackIfUrlMatches
      : [forceFallbackIfUrlMatches]

    return patterns.some( pattern => {
      if ( pattern instanceof RegExp ) return pattern.test( loadedSrc )
      return loadedSrc.toLowerCase().includes( String( pattern ).toLowerCase() )
    } )
  }

  handleLoad = () => {
    if ( this.state.isFallback ) return

    const loadedSrc = this.element && ( this.element.currentSrc || this.element.src )
    let { fallback = "/image/placeholder.png" } = this.props

    if ( this.shouldForceFallback( loadedSrc ) ) {
      this.changeSrc( fallback )
    }
  }

  changeSrc = ( newSrc ) => {
    let { src, fallback = "/image/placeholder.png", ...other } = this.props
    if ( !src ) src = fallback
    //console.log( `Image Not Found: ${src}` )


    this.times++
    if ( this.times > 2 ) return
    if( typeof(fallback) === "object"){
      this.setState({Child: fallback})
    }
    if ( newSrc === null ) {
      this.setState( { noImage: true } )
      this.element.src = transparent1x1
    } else {
      this.element.src = newSrc
      this.setState( { isFallback: true } )
    }
  }

  render() {
    const {Child} = this.state
    let { src, fallback = "//placehold.it/420x240/f5f5f5/&text=%20", className="", ...other } = this.props
    const noSrcProvided = !src
    if ( !src ) src = fallback

    if( Child) return Child
    if ( this.state.noImage ){
      return null
    }

    const isFallback = this.state.isFallback || noSrcProvided
    let classes = className
    if ( isFallback ) classes += " isFallback"
    return (
      <img src={src}
           className={classes}
           onLoad={this.handleLoad}
           onError={() => this.changeSrc( fallback )}
           ref={el => this.element = el}
           {...other} />
    )
  }
}


export default ImageWithFallback



// WEBPACK FOOTER //
// ./src/components/ImageWithFallback.js